module.exports = __webpack_public_path__ + "img/doomstalker.f688b464.png";